import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const businessAllyService = {
  getBusinessAlly: async (params) => {
    const response = await authInstance
      .get(`${url}/businessAlly/list?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  createBusinessAlly: async (data) => {
    const response = await authInstance
      .post(`${url}/businessAlly/create?`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  updateBusinessAllyStatus: async (id, data) => {
    const response = await authInstance
      .put(`${url}/businessAlly/${id}/updateStatus`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
